import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Seo from '@components/Seo';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import MemberRules from '../../components/MemberRules/MemberRules';
import getServerSideData from '../../utils/getServerSideData';
import PreLoaderOverlay from '../../components/common/PreLoaderOverlay';
import FootText from '../../components/Footer/FooterText';
import getIsUnderMaintenance from '../../utils/getUnderMaintenance';

const MemberRulesPage = () => {
    const { siteName, preferredSiteName } = useSiteInfo();
    return (
        <>
            <Seo />
            <PreLoaderOverlay />
            <div className="app">
                <div className="header">
                    <div className="header__main">
                        <div className="logo" />
                    </div>
                </div>
                <MemberRules />
                <div className="footer">
                    <div className="footer__cpr">
                        <div className="logo" role="mobile-visible" />
                        <span className="text">
                            <FootText siteName={preferredSiteName || siteName} />
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};

export async function getServerSideProps({ req, locale }) {
    const {
        host,
        apiHost,
        serverResponseJson,
        headers,
        ip,
        envConfig,
    } = await getServerSideData({ req });

    if (serverResponseJson?.isDeniedIp) {
        return {
            redirect: {
                permanent: false,
                destination: `/${locale}/accessDenied`,
            },
        };
    }

    if (getIsUnderMaintenance(serverResponseJson?.underMaintenanceInfo)) {
        return {
            redirect: {
                permanent: false,
                destination: `/${locale}/underMaintenance`,
            },
        };
    }

    return {
        props: {
            ...(await serverSideTranslations(locale, ['common'])),
            ...serverResponseJson,
            host,
            apiHost,
            ip,
            serverResponseJson,
            headers,
            locale,
            envConfig,
        },
    };
}

export default MemberRulesPage;
